<template>
  <div class="tutorials-topic-list">
    <p
      v-if="category?.subtitle"
      class="tutorials-topic-list__subtitle"
    >
      {{ category.subtitle }}
    </p>
    <p class="tutorials-topic-list__section-label">Topics</p>
    <ul class="tutorials-topic-list__items">
      <TutorialsListRow
        v-for="topic in topics"
        :key="topic.id"
        :name="topic.name"
        :secondary-text="topic.description"
        :info-text="topic.infoText"
        :disabled="!topic.isAvailable"
        :data-cy="`tutorials-topic-${topic.id}`"
        @click="emit('select-topic', topic.id)"
      />
    </ul>
  </div>
</template>

<script setup>
const props = defineProps({
  categoryId: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['select-topic']);

const { category, topics } = useOnboardingTopics(props.categoryId);
</script>

<style lang="scss" scoped>
.tutorials-topic-list {
  &__subtitle {
    @apply tw-m-0 tw-px-4 tw-py-6 tw-text-base tw-font-regular tw-text-black-500;
  }

  &__section-label {
    @apply tw-m-0 tw-px-4 tw-pb-2 tw-text-sm tw-font-regular tw-text-text-link-on-light;
  }

  &__items {
    @apply tw-m-0 tw-list-none tw-p-0;
  }
}
</style>
